import React, { useId } from 'react';
import { cn } from '../../../lib/utils';

interface DotPatternProps extends Omit<React.SVGProps<SVGSVGElement>, 'width' | 'height'> {
  width?: number;
  height?: number;
  cx?: number;
  cy?: number;
  cr?: number;
  className?: string;
}

export const DotPattern: React.FC<DotPatternProps> = ({
  width = 18,
  height = 18,
  cx = 1,
  cy = 1,
  cr = 1.2,
  className,
  ...props
}) => {
  const id = useId();
  return (
    <svg
      aria-hidden="true"
      className={cn('pointer-events-none absolute inset-0 h-full w-full fill-slate-300/60', className)}
      {...props}
    >
      <defs>
        <pattern id={id} width={width} height={height} patternUnits="userSpaceOnUse">
          <circle cx={cx} cy={cy} r={cr} />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
};
